import React from 'react';
import { string, func, bool } from 'prop-types';
import styles from './styles/styles.module.scss';

const Toggle = props => {
  const labelClass = props.showLabelFirst ? styles.reverse : styles.wrapper;
  
  return (
    <div id={styles.tempoverridewrapper} className={`${labelClass} ${props.className}`}>
      <input className={styles.itoggle} type="checkbox" name={props.name} id={props.inputId} onChange={props.onChange} checked={props.checked} />
      <label htmlFor={props.inputId} />
      <span className={styles.label}>{props.label}</span>
    </div>
  );
};

Toggle.defaultProps = {
  showLabelFirst: true,
  name: '',
  className: null
};

Toggle.propTypes = {
  inputId: string.isRequired,
  onChange: func.isRequired,
  checked: bool.isRequired,
  label: string.isRequired,

  showLabelFirst: bool,
  name: string,
  className: string
};

export default Toggle;
